import { showErrorToast } from "src/components/AlertToastify/AlertToastify";

export const getLatestPrivacyPolicy = async (): Promise<any> => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/privacy-policy/latest`;

    const response = await fetch(url, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error("Failed to fetch privacy policy");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching latest privacy policy:", error);
    showErrorToast("Failed to fetch privacy policy");
    throw error;
  }
};
